import React, { useState, useEffect } from "react";
// import "./CheckWarranty.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
// import ROUTES_NAVIGATION from "../../../../routes/routes";
// import viewIcon from "../../../../../Assets/icons/ClaimIcon.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import DownloadSVG from "../../../../../Assets/icons/DownloadIconMIS.svg";
import download from "../../../../../Assets/icons/download.svg";
import print from "../../../../../Assets/icons/printer.svg";
import CustomMisTable from "../../../../customComponents/customMisReportTable";
import { showErrorAlert } from "../../../../customComponents/CustomSweetAlert/errorsweetalert";
import { FiDownload } from "react-icons/fi";
// import DetailsTable from "../../Admin/OrderManagement/CustomOrderTable/CustomOrderTable";

const AdminSalesReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [variantOptions, setVariantOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});
  const [vinNoData, setVinNoData] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  // const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [itemsPerPage] = useState(10);

  const [dealerOption, setDealerOptions] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealerId = localStorage.getItem("dealerId");
  localStorage.removeItem("JobCardComplainData");

  // useEffect(() => {
  //     fetchJobCardList();
  // }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchSalesReport(newPage);
  };

  useEffect(() => {
    const modelId = filterFormData.modelId;
    if (modelId) {
      fetchColorOptions(modelId);
    }
  }, [filterFormData.modelId]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  // const fetchJobCardList = async () => {
  //     const allfilteredData = filters;
  //     const payload = {
  //         // business_partner_id: 1,
  //         // dealerId: dealerId || "",
  //         // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
  //         // fromDate:"",
  //         // toDate:"",
  //         state_id: "",
  //         services_by: "",
  //         servicesValue_Id: "",
  //         orderBy: "po_id desc",
  //         page: 0,
  //         pageSize: 10,

  //         fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
  //         toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
  //     }
  //     try {
  //         // setTableLoader(true)
  //         const response = await axiosInstance.post(
  //             "/admin/mis-report", payload,
  //             {
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                     Authorization: `Bearer ${token}`,
  //                 },
  //             }
  //         );
  //         // setTableLoader(false)
  //         const formattedData = response?.data?.data?.data.map((item, index) => ({
  //             ...item,
  //             item_name: item.item_name || "--",
  //             model_name: item.model_name || "--",
  //             variant_name: item.variant_name || "--"
  //         }))
  //         const totalRecordsData = response?.data?.data?.totalRecords
  //         setTotalRecords(totalRecordsData);
  //         setVinNoData(formattedData)

  //     } catch (error) {
  //         console.error("Error fetching business partners:", error);
  //         // setIsSearchPerformed(false);
  //     }
  // };
  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate("job-card-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Dealer Name",
    "Date",
    "PO Number",
    "Order Qty",
    "Approved Qty",
    "Delivered Qty",
    // "VALUE",
    // "Payment Status",
    // "Model",
    // "Variant",
    // "INVOICE COPY",
    "Dealer Approval",
    // "Total Accessories",
    "Invoice Copy",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    Date: "po_date",
    "Dealer Name": "dealer_name",
    "PO Number": "po_number",
    "Order Qty": "orderQty",
    "Approved Qty": "approvedQty",
    "Delivered Qty": "total_delivered_qty",
    VALUE: "-",
    "Payment Status": "paymentStatus",
    "Dealer Approval":"dealer_approval",
    "INVOICE COPY": "invoiceCopy",
    Model: "model_name",
    Variant: "variant_name",
    // "Total Accessories": "total_accessories",
    // "Vin No.":"dealer_name",
    // "Days":"remaining_days",
    //  "Warranty From":"warrantyFrom",
    // "Warranty To":"warrantyTo",
    "Invoice Copy": [
      { type: "invoiceCopy", icon: download, label: "invoiceCopy" },
      { type: "ewayBill", icon: print, label: "ewayBill" },
    ],
  };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  // useEffect(() => {

  //     fetchJobCardList();
  // }, [filters]);

  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchJobCardList();
  // };
  // useEffect(() => {
  //     if (searchTerm === "") {
  //         fetchJobCardList();
  //     }
  // }, [searchTerm]);

  // const handleSearch = () => {
  //   setFilters({
  //     vinNumber: filterFormData.searchTerm || null
  //   });
  //   // setIsSearchPerformed(true);
  //   fetchJobCardList();
  // };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClear = () => {
    setFilterFormData({});
  };
  const handleClaim = () => {
    console.log("clicked");
    // navigate(ROUTES_NAVIGATION.ADDJOBCARD)
  };

  const DownLoadPdf = (row) => {
    console.log(row, "clicked");
    const pdfURL = row?.invoiceCopy;
    if (pdfURL) {
      window.open(pdfURL, "_blank", "noopener,noreferrer");
    } else {
      console.error("No PDF URL found in the row data");
    }
  };

  const handleEwayBillDownload = (row) =>{
    console.log(row, "clicked");
    const pdfURL = row?.ewayBill;
    if (pdfURL) {
      window.open(pdfURL, "_blank", "noopener,noreferrer");
    } else {
      console.error("No PDF URL found in the row data");
    }
  }

  const handleDeliveryChalan = (row) =>{
    console.log(row, "clicked");
    const pdfURL = row?.delevryChallan;
    if (pdfURL) {
      window.open(pdfURL, "_blank", "noopener,noreferrer");
    } else {
      console.error("No PDF URL found in the row data");
    }
  }

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, "responseVal");

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    // const colorId = formData.color
    const modelId = filterFormData.modelId;
    const dealerIdVal = filterFormData.dealerId;
    const colorIdVal = filterFormData.colorId;

    if (modelId && dealerIdVal && colorIdVal) {
      fetchVariantOptions(modelId, dealerIdVal, colorIdVal);
    }
  }, [filterFormData.modelId, filterFormData.dealerId, filterFormData.colorId]);

  const fetchVariantOptions = async (modelId, dealerIdVal, colorIdVal) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          // color_id: colorId,
          model_id: modelId,
          dealer_id: dealerIdVal,
          color_id: colorIdVal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const fetchSalesReport = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;

    try {
      const payload = {
        dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
        stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
        // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
        // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
        fromDate: formatDate(allfilteredData?.fromDate),
        toDate: formatDate(allfilteredData?.toDate),
        modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
        colorId: allfilteredData?.colorId || null,
        variantId: allfilteredData?.variantId
          ? allfilteredData?.variantId
          : null,
        paymentStatus: null,
        orderBy: "po_id desc",
        page,
        pageSize,
      };

      const response = await axiosInstance.post("/mis/sale-report", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const salesData = response?.data?.data || [];
        const formattedData = response?.data?.data?.data;
        setVinNoData(formattedData);

        const totalRecordsData = response?.data?.data?.totalRecords;
        setTotalRecords(totalRecordsData); // or use a separate `totalRecords` field if available

      // const fullData = response?.data?.data?.data || [];
      // setTotalPages(Math.ceil(fullData.length / itemsPerPage));
      // setCurrentPage(0); // reset to first page

        setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      // console.log("Formatted Sales Report Data:", fullData);
    } catch (error) {
      console.error("Failed to fetch sales report:", error);
    }
  };

  useEffect(() => {
    fetchSalesReport();
  }, []);

  // const paginatedData = vinNoData.slice(
  //   currentPage * itemsPerPage,
  //   currentPage * itemsPerPage + itemsPerPage
  // );

  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-5",
    },
    // {
    //   // name: "variant",
    //   name: "modelId",
    //   label: "Model",
    //   placeholder: "Select Model",
    //   type: "dropdown",
    //   options: modelOptions,
    //   // required: true,
    //   gridClass: "col-lg-3",
    //   // validation: { required: true }
    // },
    // {
    //   name: "colorId",
    //   label: "Color",
    //   placeholder: "Color",
    //   type: "dropdown",
    //   options: colorOptions,
    //   // disabled:true,
    //   gridClass: "col-lg-3",
    // },
    // {
    //   // name: "variant",
    //   name: "variantId",
    //   label: "Variant",
    //   placeholder: "Select Variant",
    //   type: "dropdown",
    //   options: variantOptions,
    //   // required: true,
    //   gridClass: "col-lg-3",
    //   // validation: { required: true },
    // },
    // {
    //   name: "fromDate",
    //   label: "From Date",
    //   type: "date",
    //   maxDate: new Date(),
    //   // required: true,
    //   gridClass: "col-lg-3",
    // },
    // {
    //   name: "toDate",
    //   label: "To Date",
    //   type: "date",
    //   maxDate: new Date(),
    //   // required: true,
    //   gridClass: "col-lg-3",
    // },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      modelId: filterFormData?.modelId ? filterFormData?.modelId : null,
      variantId: filterFormData?.variantId ? filterFormData?.variantId : null,
      dealerId: filterFormData?.dealerId ? filterFormData?.dealerId : null,
      colorId: filterFormData?.colorId || null,
    });
  };
  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    // fetchJobCardList();
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      // orderBy: "po_id desc",
      // page: 0,
      // pageSize: 10,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,

      // dealerId:allfilteredData?.dealerId,
      // stateId:null,
      // fromDate:null,
      // toDate:null,
      // modelId:null,
      // variantId:null,
      paymentStatus: null,
      dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
      variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
      colorId: allfilteredData?.colorId || null,
      orderBy: "po_id desc",
      page: 0,
      pageSize: 10,
    };

    try {
      const response = await axiosInstance.post(
        "/mis/sale-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important: Ensures the response is treated as a file
        }
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "text/csv" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "sales report.csv"; // Set the file name
      link.style.display = "none";

      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);

      const errorMessage = error?.response?.statusText;
      console.log(errorMessage, "errorMessage");

      const alertText =
        errorMessage === "Not Found"
          ? "Record not found"
          : errorMessage || "Something went wrong";

      showErrorAlert({
        title: "Warning",
        text: alertText,
        callback: () => {
          console.log("Error alert confirmed");
        },
      });
    }
  };

  useEffect(() => {
    fetchSalesReport(0, 10);
  }, [filters]);

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div
          style={{ width: "100%" }}
          className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2"
        >
          <div
            style={{
              lineHeight: "1px",
              display: "flex",
              flexDirection: "column",
              paddingTop: "30px",
            }}
          >
            <div>
              <p className="ServiceBreadcrumbs">Home / Report / MIS Report </p>
            </div>
            <div>
              <h5
                style={{ fontWeight: "600" }}
                className="checkWarrantyHeading"
              >
                Dealer Sales Report
              </h5>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            {/* <img
              onClick={downloadExcel}
              src={DownloadSVG}
              alt="downloadSvg"
              style={{ paddingTop: "33px", cursor: "pointer" }}
            /> */}
            <div
              onClick={downloadExcel}
              className="flte-btnnn"
              style={{ borderRadius: "38px", cursor: "pointer",fontSize:"15px" }}
            >
              Sales Report Download
              <span>
                <FiDownload
                  className="downloadexcel-misreportsales"
                  style={{ cursor: "pointer" }}
                  size={22}
                />
              </span>
            </div>
            <div></div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView"></div>

        <div style={{ paddingTop: "20px" }}>
          {/* <CustomMisTable
            data={vinNoData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={10}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            // isADDcomplainTable="true"
            pdfDownLoad={DownLoadPdf}
            currentPage={currentPage}
          /> */}
          <CustomMisTable
            data={vinNoData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            pdfDownLoad={DownLoadPdf}
            handleEwayBillDownload={handleEwayBillDownload}
            handleDeliveryChalan={handleDeliveryChalan}
          />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default AdminSalesReport;
